// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3WsPV{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._3M8wZ{fill:#078285;height:20px;width:20px}", ""]);
// Exports
exports.locals = {
	"icon": "_3WsPV",
	"icon__icon": "_3M8wZ"
};
module.exports = exports;
